import dayjs from 'dayjs'

export default {
    data() {
      return {
      };
    },
  
    methods: {

        normalizzaTS(aDate) {
            //2021-09-15-13:48:18.399
            if (aDate !== undefined) {
                const dataSplit = aDate.split("-");
                if (dataSplit.length == 1) {
                    return "1970-01-01 " + aDate;
                } else {
                    return dataSplit[0] + "-" + dataSplit[1] + "-" + dataSplit[2] + " " + dataSplit[3];
                }
            }
            return aDate;
        },

        isValidDate(dateToValidate){
            const tt0 = this.normalizzaTS(dateToValidate);
            const t0 = dayjs(this.getIsoDate(tt0))
            return t0.isValid();
        },

        calcolaOrario(guntime, time, timeFormat = 'HH:mm:ss.SSS'){
            var utc = require('dayjs/plugin/utc')
            dayjs.extend(utc);
            
            const tt0 = this.normalizzaTS(guntime);
            const tt1 = this.normalizzaTS(time);
            
            console.log("Calcolo orario:" + tt0 + " + " + tt1 )

            const t0 = dayjs(this.getIsoDate(tt0))+ 3600000;
            const t1 = dayjs(this.getIsoDate(tt1))+ 3600000;

            let result = dayjs(t0.valueOf()+t1.valueOf()).utc().format(timeFormat);

            return result

        },


        diffTime(tempo1, tempo0, gapFormat = 'HH:mm:ss') {
            var utc = require('dayjs/plugin/utc')
            dayjs.extend(utc);

            const tt0 = this.normalizzaTS(tempo0);
            const tt1 = this.normalizzaTS(tempo1);

            const t0 = dayjs(this.getIsoDate(tt0)).utc();
            const t1 = dayjs(this.getIsoDate(tt1)).utc();

            var duration = (t1.diff(t0));
            if (gapFormat == undefined) {
                gapFormat = 'HH:mm:ss'
            }
            let result = dayjs(duration).utc().format(gapFormat);
            //if (result.startsWith("+00:"))
            //    result = "+" + result.substring(4, result.length);
            return result;
        },

        diffSeconds(tempo1, tempo0) {
            
            var utc = require('dayjs/plugin/utc')
            dayjs.extend(utc);

            const tt0 = this.normalizzaTS(tempo0);
            const tt1 = this.normalizzaTS(tempo1);

            

            const t0 = dayjs(this.getIsoDate(tt0)).utc();
            const t1 = dayjs(this.getIsoDate(tt1)).utc();

            return (t1.diff(t0)) / 1000;
           
        },

        riduci(aTime) {
            if (aTime !== undefined && isNaN(aTime)) {

               if (aTime.startsWith("00:") || aTime.startsWith("00.")) {
                    return aTime.substring(3, aTime.length);
                } else if (aTime.startsWith("00:0") || aTime.startsWith("00.0")) {
                    return aTime.substring(5, aTime.length);
                } else if (aTime.startsWith("+00:")) {
                    return aTime.substring(4, aTime.length);
                } else if (aTime.startsWith("+0:")) {
                    return aTime.substring(3, aTime.length);
                } else if (aTime.startsWith("+")) {
                    return aTime.substring(1, aTime.length);
                } else if (aTime.startsWith("0")) {
                    return aTime.substring(1, aTime.length);
                }
            }
            return aTime;
        },

        getTime(tempo) {
            let t = tempo.split(".");
            return t[0];
        },

        getIsoDate(aDate) {
            const res = aDate.replace(/-/g, '/').replace('T', ' ');
            //console.log("getIso:" + aDate + " >> " + res);
            return res;
        },

        calcolaMedia(tempo0, meters, unit) {
            let res = "-";
            //console.log("Media>" + tempo0 + " - " + meters)
            if (tempo0 !== undefined && isNaN(tempo0) && meters > 0 ) {
                var utc = require('dayjs/plugin/utc')
                 dayjs.extend(utc);

            const tt0 = this.normalizzaTS(tempo0);
            const t0 = dayjs(this.getIsoDate(tt0));

            const hh = t0.get('hours') * 3600;
            const mm = t0.get('minutes') * 60;
            const ss = t0.get('seconds');

            let seconds = hh + mm + ss;

            if (unit == undefined || unit == 'Min/Km') {
                let velocita = meters / seconds;
                velocita = 1000 / velocita;
                let resto = (velocita % 60) / 100;
                if (resto > 0.590)
                    resto = 0.59;
                velocita = Math.floor(velocita / 60) + resto;
                velocita = (Math.round((velocita + Number.EPSILON) * 100) / 100).toFixed(2);
    
                res = (velocita)
            } else if ( unit == 'Km/h'){
                const min = (( seconds ) / 60);
				const metriAlMin = (meters / min);
				const velocita = ( (metriAlMin * 60) / 1000 ).toFixed(2);;
				res = (velocita) ;
            } else if (unit == 'Min/100mt' ) {
                let velocita = meters / seconds;
				velocita = 100 / velocita;
				let resto = (velocita % 60) / 100;
                if (resto > 0.590)
                    resto = 0.59;
                velocita = Math.floor(velocita / 60) + resto;
                velocita = (Math.round((velocita + Number.EPSILON) * 100) / 100).toFixed(2);
    
                res = (velocita)
            }
            
            return res;
            }
            return "-";
        },

        formatTimestamp(time, timeFormat = 'HH:mm:ss.SSS'){
            const tt1 = this.normalizzaTS(time);
            let result = dayjs(tt1).format(timeFormat);


            if (timeFormat.endsWith(".SS") || timeFormat.endsWith(".S") ) {
                //console.log("Formatta: " + tt1 + " con formatter "+ timeFormat+" in " + result)
                if (timeFormat.endsWith(".SS") ) {
                    timeFormat = timeFormat +"S";
                    result = dayjs(tt1).format(timeFormat);
                    result = result.substring(0, result.length-1 );
                } else if (timeFormat.endsWith(".S")){
                    timeFormat = timeFormat +"SS";
                    result = dayjs(tt1).format(timeFormat);
                    result = result.substring(0, result.length-2 );
                }
            }
            
            return result
            
        },



    }
}